import React, { useCallback, useEffect } from 'react';
import LinkLang from '../../Wraps/LinkLang';
import styles from './styles.module.scss';
import { useSessionStorage } from '../../../hooks/useSessionStorage';

import ApiCatalogCMS from '../../../api/Catalog/CategoryCMS';

const List = ({ spanish }) => {
  const [categoriesList, setCategoriesList] = useSessionStorage(
    'cmsCategories',
    []
  );

  const getListCategoriesInfo = useCallback(async () => {
    try {
      const resp = await ApiCatalogCMS.getCategories();
      if (resp && resp.length) {
        setCategoriesList(resp);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getListCategoriesInfo();
  }, [getListCategoriesInfo]);

  const orderedList = categoriesList?.sort((a, b) => a?.Position - b?.Position);

  return (
    <div className={styles.container}>
      <h5>{spanish ? 'CATEGORÍA' : 'CATEGORY'}</h5>
      <ul className={styles.list}>
        {orderedList.map((item) => (
          <li key={item.id} className={styles.item}>
            <LinkLang
              to={`/category/${item?.SLUG}`}
              state={{
                categoryId: item?.categoryID,
                categoryName: item.NameSpanish,
              }}
            >
              {spanish ? item?.NameSpanish : item?.NameEnglish}
            </LinkLang>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default List;
